import React from 'react';

import { Box } from '~/components/blocks';
import { WebVisitorAppointmentDetailFragment } from '~/graphql/generated/graphql';
import { theme } from '~/styles/theme';

import { WebVisitorProfile } from './WebVisitorProfile';

type Props = {
  appointment: WebVisitorAppointmentDetailFragment;
};

export const ReceptionPane = React.memo((props: Props) => {
  const { appointment } = props;

  return (
    <Box position="relative" height="100%" overflow="auto">
      <Box padding={theme.space.l} overflow="auto">
        <WebVisitorProfile appointment={appointment} />
      </Box>
    </Box>
  );
});

ReceptionPane.displayName = 'ReceptionPane';
